import PropTypes from 'prop-types';
import propject from '#props/project';
import account from '#props/account';

export default {
  dispatch: PropTypes.func,
  projects: PropTypes.arrayOf(PropTypes.shape({
    ...propject,
    users: PropTypes.number || null,
    devices: PropTypes.number || null
  })),
  account: PropTypes.shape(account),
  hideExpired: PropTypes.bool
};
